import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
  useRef,
} from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import axios from 'axios';
import {
  MembersData,
  PopupRightSide,
  MemberList,
  // CKEditorTrello,
  Activity,
  CKCommentEditorTrello,
  CartTitle,
  BackgroundCover,
  AttachmentSection,
  LabelPopup,
  DatesPopup,
  AttachmentPopup,
  CoverPopup,
  AttachmentModal,
  MoveDepartment,
  Join,
  DateShow,
  AddClient,
  ChangeTeam,
  AddTeam,
} from '../../component';
import { UTILS } from '../../constants';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap/Button';
import { DescEditor } from '../descEditor';
import { LuLoader } from 'react-icons/lu';
import loader from '../../assets/images/loader.gif';
import { useNavigate, useLocation } from 'react-router-dom';
// import Testing from "../activity/testActivity";

export const Popup = ({
  card,
  modalShow,
  handleClose,
  colors,
  fetchCards,
  getTaskId,
  client,
  team,
  board,
  handleCoverChange,
  handlecardtitleapp,
  handlecarduntrash,
  fetchCardsForPopUp,
}) => {
  const [getId, setgetId] = useState(null);
  const [files, setFiles] = useState([]);
  const [departments, setDepartments] = useState([]);
  // const [departmentId, setDepartmentID] = useState('');
  const [error, setError] = useState(null);
  const [cardDetail, setCardDetail] = useState(card);
  const [boardlist, setBoardlist] = useState(board);
  const [labelData, setLabelData] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  let [attachmentsFile, setAttachmentsFile] = useState([]);
  let [showStatus, setShowStatus] = useState(false);
  const [showLoadingAttachment, setShowLoadingAttachment] = useState(false);
  let [showCover, setShowCover] = useState(null);
  let [loading, setLoading] = useState(false);
  const [editorVisible, setEditorVisible] = useState(false);
  let [saveDate, setSavedDate] = useState(null);
  let [people_users, setPeople] = useState(null);
  let [Commentdata, setCommentdata] = useState(null);

  let [coverAttactment, setCoverAttachment] = useState(null);
  let [checkCoverAttachment, setCheckCoverAttachment] = useState(false);
  const isInitialMount = useRef(true);
  const prevModalShowRef = useRef();
  useEffect(() => {
    // Store the current modalShow in the ref for the next render
    prevModalShowRef.current = modalShow;
  });
  const navigate = useNavigate();
  const location = useLocation();
  let dropdownLi;

  if (cardDetail?.deleted_at) {
    dropdownLi = [];
  } else {
    dropdownLi = [
      {
        id: 1,
        labelTitle: 'Labels',
      },
      {
        id: 2,
        labelTitle: 'Dates',
      },
      {
        id: 3,
        labelTitle: 'Attachment',
      },
      {
        id: 4,
        labelTitle: 'Cover',
      },
      {
        id: 6,
        labelTitle: 'Move Department',
      },
      {
        id: 7,
        labelTitle: 'Add Client',
      },
      {
        id: 8,
        labelTitle: 'Add Team',
      },
    ];
  }

  const openPopup = (id) => {
    setgetId(id);
  };
  const [members, setMembers] = useState([]);
  const [showMemberList, setShowMemberList] = useState(false);
  let [pressPlusButton, setPressPlusButton] = useState(false);
  useEffect(() => {
    if (modalShow) {
      setMembers(card?.assigned_users);
      setCardDetail(card);
      if (card?.id || getTaskId);
      fetchCardDetail();
    }
  }, [card.id, modalShow]);

  const fetchCardDetail = async () => {
    if (getTaskId !== null) {
      setLoading(true);
      try {
        const randomString = Math.random().toString(36).substring(2, 5);
        const apiUrl =
          UTILS.API_url +
          `board/v1/board-list-cards/show${
            card?.id ? `/${card?.id}` : `?code=${getTaskId}`
          }?${randomString}`;

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'application/json',
            // 'X-CSRF-TOKEN': 'SFy5sniSD26URDuLPmBAKy1C9KocZq9mXWFk0IWA',
          },
        });

        setCardDetail(response?.data?.board_list_card);
        setAttachmentsFile(response?.data?.board_list_card?.attachments);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching board data:', error);
        setLoading(false); // Ensure loading is turned off in case of error
      }
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const apiUrl = UTILS.API_url + `board/v1/users`;
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'application/json',
          },
        });
        const userNames = response?.data?.users?.map((user) => user.name) || [];
        setPeople(userNames);
      } catch (error) {
        console.error('Error fetching board data:', error);
      }
    };

    fetchUsers();
  }, []);
  // useEffect(() =>{
  //   if (isInitialMount.current === true) {
  //     isInitialMount.current = false; // Set to false after the first render
  //     return; // Skip the first call
  // }
  //   if(modalShow == true){
  //     fetchCardDetail()
  //   }
  // },[modalShow == true])

  //  add label
  const addLabelFunc = async (label_id, assigned) => {
    try {
      const apiUrl =
        UTILS.API_url + 'board/v1/board-list-cards/label/assign-unassign';
      const newStatus = assigned ? 0 : 1;
      // Construct FormData
      const formData = new FormData();
      formData.append('task_id', card?.id);
      formData.append('label_id', Number(label_id));
      formData.append('assigned', newStatus);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      // setLabelData(response?.data.label)
    } catch (error) {
      console.error('Error fetching board data:', error);
    }
  };

  // add label
  const addNewLabelFunc = async (label) => {
    try {
      const apiUrl = UTILS.API_url + 'board/v1/board-list-cards/label/create';

      // Construct FormData
      const formData = new FormData();
      formData.append('task_id', Number(cardDetail?.id));
      formData.append('label', label);
      formData.append('label_color_id', selectedColor);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setLabelData([...labelData, response?.data?.label]);
    } catch (error) {
      console.error('Error fetching board data:', error);
    }
  };

  const updateLabelFunc = async (label_id, label, label_color_id) => {
    try {
      const apiUrl = UTILS.API_url + 'board/v1/board-list-cards/label/update';

      // Construct FormData
      const formData = new FormData();
      formData.append('task_id', card?.id);
      formData.append('label_id', label_id);
      formData.append('label', label);
      formData.append('label_color_id', label_color_id);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      console.error('Error fetching board data:', error);
    }
  };
  // const fetchCardss = async () => {
  //   const randomString = Math.random().toString(36).substring(2, 5);
  //   var _URL =
  //   UTILS.API_url +
  //   `board/v1/board-lists?cache=${randomString}&department_id=${departmentId}`;

  //   try {
  //     const response = await axios.get(_URL, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
  //       },
  //     });
  //     // console.log("response.data.board_lists", response);
  //     setTeam(response.data.teams);
  //     setDepartments(response.data.departments);
  //     setLoading(false);
  //   } catch (err) {
  //     setError(err);
  //   }
  // };

  const MAX_FILE_SIZE = 100 * 1024 * 1024; // 2 MB limit

  const handleFileChange = (e) => {
    const files = e.target.files;
    const errors = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > MAX_FILE_SIZE) {
        errors.push(`${file.name} is too large. Maximum size allowed is 10MB.`);
      }
    }

    if (errors.length > 0) {
      errors.forEach((error) => toast.error(error)); // Show each error using toast
    } else {
      console.log('Selected files are valid:', files);
      setFiles(e.target.files);
      setgetId(null);
    }
  };
  const handleCommentdata = (data) => {
    console.log('comment Data---> ', data);
    setCommentdata(data);
    console.log('current comment in data---> ', Commentdata);
  };

  const handleFileCoverChange = (data) => {
    handleCoverChange(data, card?.id, cardDetail?.board_list?.id);
    setCardDetail((prevState) => ({
      ...prevState,
      ...data, // Spread operator to merge existing state with new data
    }));
    // setFiles(e.target.files);
    setCheckCoverAttachment(true);
    setgetId(null);
  };
  const handlecardtitle = (Id, title) => {
    handlecardtitleapp(card?.id, cardDetail?.board_list?.id, title);
  };
  const handleUntrash = (Id) => {
    handlecarduntrash(Id);
    setTimeout(() => {
      fetchCards();
      fetchCardDetail();
    }, 3000);
  };

  // Dropdown Attachment
  const CheckFunc = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles);
  }, []);

  useEffect(() => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('task_id', card?.id ? card?.id : cardDetail.id);
      Array.from(files).forEach((file, index) => {
        formData.append(`attachments[${index}]`, file);
      });

      setShowLoadingAttachment(true);
      const randomString = Math.random().toString(36).substring(2, 5);
      axios
        .post(
          `${UTILS.API_url}board/v1/board-list-cards/add-attachments?${randomString}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((response) => {
          setShowLoadingAttachment(false);
          toast.success(response.data.success);
          if (response.data.errors) {
            Object.keys(response.data.errors).forEach((key) => {
              // Each key will have an array of error messages
              const errorMessages = response.data.errors[key];
              errorMessages.forEach((error) => {
                toast.error(error); // Show each error message
              });
            });
          }
          setAttachmentsFile([
            ...attachmentsFile,
            ...response.data.attachments,
          ]);
          fetchCardDetail();
          if (checkCoverAttachment) {
            setCoverAttachment(response.data.attachments);
            setCheckCoverAttachment(false);
          }
          fetchCards();
          setFiles([]);
        })
        .catch((error) => {
          console.error('Error uploading attachments:', error);
        });
    }
  }, [files]);

  // const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
  //   onDrop: CheckFunc,
  //   noClick: true,
  //   accept: {
  //     'image/*': ['.jpg', '.jpeg', '.png', '.gif'],
  //     'application/pdf': ['.pdf'],
  //     'application/msword': ['.doc', '.docx'],
  //     'application/vnd.ms-excel': ['.xls', '.xlsx'],
  //     'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
  //     'text/plain': ['.txt'],
  //     'application/zip': ['.zip'],
  //   },
  //   maxSize: 10 * 1024 * 1024, // 10 MB in bytes
  //   onDropRejected: (rejectedFiles) => {
  //     rejectedFiles.forEach(file => {
  //       if (file.size > 10 * 1024 * 1024) {
  //         console.log(`${file.name} is too large. Maximum size is 10 MB.`);
  //       }
  //     });
  //   }
  // });

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({
      onDrop: (acceptedFiles, rejectedFiles) => {
        CheckFunc(acceptedFiles);

        // Handle rejected files
        if (rejectedFiles.length > 0) {
          // rejectedFiles.forEach(file => {
          //   if (file.errors) {
          //     file.errors.forEach(error => {
          //       toast.error(`${file.file.name} was rejected: (Type: ${error.type}`);
          //       // toast.error(`${file.file.name} was rejected: ${error.message}`);
          //       // toast.error(`${file.file.name} was rejected: File is larger than 10MB`);

          //     });
          //   }
          // });
          rejectedFiles.forEach((file) => {
            file.errors.forEach((error) => {
              console.log(error);
              // Determine the error type
              let errorMessage = `${file.file.name} was rejected: ${error.message}`;

              // Optional: Customize the message based on error type
              if (error.type === 'file-too-large') {
                errorMessage += ' (This file is too large.)';
              } else if (error.type === 'file-invalid-type') {
                errorMessage += ' (This file type is not allowed.)';
              }

              toast.error(errorMessage);
            });
          });
        }
      },
      noClick: true,
      accept: {
        'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc', '.docx'],
        'application/vnd.ms-excel': ['.xls', '.xlsx'],
        'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
        'text/plain': ['.txt'],
        'application/zip': ['.zip'],
        'application/x-rar-compressed': ['.rar'], // RAR
        'message/rfc822': ['.eml'], // EML
        'video/mp4': ['.mp4'], // MP4
        'application/octet-stream': ['.rp'],
      },
      maxSize: 100 * 1024 * 1024, // 10 MB
    });

  useEffect(() => {
    if (modalShow == false) {
      setAttachmentsFile([]);
      setLabelData([]);
      setSavedDate(null);
      setgetId(null);
      setCommentdata(null);
      const urlWithoutCode = location.pathname;
      navigate(urlWithoutCode, { replace: true });
    }
  }, [modalShow == false]);
  // useEffect(() => {
  //   if(cardDetail != [] && modalShow){
  //       // fetchCardDetail();
  //   }
  // }, [modalShow]);

  const onShowModal = () => {
    setgetId(0);
    setPressPlusButton(true);
  };

  return (
    <div>
      <Modal
        show={modalShow}
        className="create-project-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={true}
        onHide={handleClose}
      >
        {loading ? (
          <div
            className="text-center"
            style={{
              maxHeight: 'auto',
              minHeight: '80vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* <LuLoader className="animate-spin text-gray-500" size={24} /> */}
            <img
              src={'https://tgcrm.net/public/assets/images/cxm-loader.webp'}
              alt="loader"
              style={{ width: '48px' }}
              className="zmdi-hc-spin"
            />
            {/* <p>Loading...</p> */}
          </div>
        ) : (
          <div {...getRootProps({ className: 'dropzonePopup' })}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <div className="dropzoneHide">Drop the files here ...</div>
            ) : (
              ''
            )}

            <BackgroundCover
              cardDetail={cardDetail}
              setShowCover={setShowCover}
              showCover={showCover}
            />

            <Modal.Header className="modal-header modal-card">
              <CloseButton
                className="close lg-icon close-modal-card"
                onClick={handleClose}
              >
                x
              </CloseButton>
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="modal-card-header"
              >
                <span class="material-symbols-outlined lg-icon">
                  laptop_mac
                </span>
                <CartTitle
                  cardDetail={cardDetail}
                  handlecardtitle={handlecardtitle}
                  handleUntrash={handleUntrash}
                />
              </Modal.Title>
              <div class="move-pop-list">
                <h6 class="mov-pop-heading">
                  <span>
                    in list {cardDetail && cardDetail?.board_list?.title}{' '}
                  </span>
                  <a
                    href="javascript:void(0);"
                    id="board-list-name"
                    class="js-open-move-from-header"
                  ></a>
                </h6>
              </div>
            </Modal.Header>

            <Modal.Body className="modal-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-9 pl-0 pr-1">
                    <div className="pop-detail">
                      {/* <aside>
                 <h4>Files</h4>
                 <ul>{files}</ul>
               </aside> */}

                      <div className="pd-one pd-one-padding labelArea">
                        <div className="membr">
                          <h5 className="labelHeading">Members</h5>
                          <ul class="mem-list card-member-list">
                            {members?.map((value) => {
                              return <MembersData user={value} />;
                            })}

                            <li className="card-member-list-static">
                              {!cardDetail?.deleted_at && (
                                <button
                                  class="btn btn-secondary"
                                  type="button"
                                  onClick={onShowModal}
                                >
                                  <i class="fas fa-plus"></i>
                                </button>
                              )}
                              {/* {showMemberList ? (
                         <div className="dropdown-menu add-member-drop member-assign">
                           <MemberList
                             updateMemnbers={(members) => {
                               console.log("poupupdateMemnbers", members);
                               setMembers(members);
                             }}
                             closeModal={() => setShowMemberList(false)}
                             cardDetail={cardDetail}
                           />
                         </div>
                       ) : (
                         ""
                       )} */}
                            </li>
                            <div class="member-profile"></div>
                          </ul>
                        </div>
                        <div className="label_section">
                          {labelData && labelData.length > 0 && (
                            <>
                              {labelData.filter((value) => value.assigned)
                                .length > 0 && (
                                <h5 className="labelHeading">Label</h5>
                              )}
                              {labelData
                                .filter((value) => value.assigned) // Filter to show only assigned labels
                                .map((value) => (
                                  <label
                                    key={value?.id}
                                    className="form-check-label"
                                    data-color-position="1"
                                    data-color-id="6"
                                    data-label-id={value?.id}
                                    aria-label="Color:"
                                    htmlFor={`labelCheck-${value?.id}-233`}
                                    style={{
                                      backgroundColor: value?.color?.value,
                                    }}
                                  >
                                    {value?.label}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                        <div className="dateLabelWrap">
                          <DateShow
                            cardDetail={cardDetail}
                            saveDate={saveDate}
                          />
                        </div>
                      </div>

                      <div className="label_section">
                        {/* {addLabel.length > 0 && (
   <>
     <p>Labels</p>
     {addLabel.map((value, index) => {
       console.log("value", value);
       return (
         <div key={index} style={{ padding: "4px" }}>
           {value.label}
         </div>
       );
     })}
   </>
 )} */}
                      </div>

                      <div className="desDetails">
                        <DescEditor
                          cardDetail={cardDetail}
                          people_users={people_users}
                        />
                      </div>

                      {/* TextEditor */}
                      <div
                        class="comment-div  d-flex align-items-start "
                        id="comment-div"
                      >
                        <div className="desc-editor">
                          {/* <Text>sdlkfj</Text> */}
                        </div>
                      </div>

                      <div class="main-attach-flex">
                        <div class="append-attachments">
                          <AttachmentSection
                            attachmentsFile={attachmentsFile}
                            setAttachmentsFile={setAttachmentsFile}
                            cardDetail={cardDetail}
                            setShowCover={setShowCover}
                            handleCommentdata={handleCommentdata}
                            handleFileCoverChange={handleFileCoverChange}
                          />
                        </div>
                        {/* <div class="append-attachments">

                
                  
                 </div> */}
                        <Activity
                          attachmentsFile={attachmentsFile}
                          cardDetail={cardDetail}
                          fetchCardDetail={fetchCardDetail}
                          people_users={people_users}
                          Commentdata={Commentdata}
                        />

                        <div
                          class="comment-div d-flex align-items-start "
                          id="comment-div"
                        >
                          {/* <div className="act-editor">
                     <CKCommentEditorTrello
                       onSave={handleSaveComments}
                       onCancel={handleCancelComment}
                       text="Write a comment..."
                       addComments={props.addComments}
                       setEditorVisibleComments={
                         props.setEditorVisibleComments
                       }
                       isEditorVisibleComments={
                         props.isEditorVisibleComments
                       }
                       editorDataComments={props.editorDataComments}
                       setEditorDataComments={props.setEditorDataComments}
                       getparams={props.getparams}
                       setEditorCommentData={props.setEditorCommentData}
                       editorCommentData={props.editorCommentData}
                       popData={popData}
                       updateComments={props.updateComments}
                     />
                   </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 px-1">
                    {/* <PopupRightSide /> */}
                    <div className="pop-list">
                      <div class="join-own">
                        <Join
                          setMembers={setMembers}
                          members={members}
                          cardDetail={cardDetail}
                        />
                      </div>
                      {cardDetail?.deleted_at ? '' : <h4>Add to Card</h4>}

                      <ul>
                        {dropdownLi.map((value) => {
                          return (
                            <li className="dropdown" key={value.id}>
                              <a
                                href="javascript:void(0);"
                                onClick={() => openPopup(value.id)}
                              >
                                <i class="far fa-user"></i>
                                {value.labelTitle}
                              </a>
                            </li>
                          );
                        })}

                        {getId == 0 ? (
                          <div
                            className={`dropdown-menu add-member-drop member-assign ${
                              getId == 0 && pressPlusButton == true
                                ? 'firstpopupPlus'
                                : 'firstpopup'
                            } `}
                          >
                            <MemberList
                              updateMemnbers={(members) => {
                                setMembers(members);
                              }}
                              closeModal={() => {
                                setShowMemberList(false);
                                setgetId(5);
                                setPressPlusButton(false);
                              }}
                              cardDetail={cardDetail}
                              setPressPlusButton={setPressPlusButton}
                            />
                          </div>
                        ) : getId == 1 ? (
                          <div
                            className={`labelDiv dropdown-menu add-member-drop ${
                              getId == 1 ? 'secondpopup' : ''
                            }`}
                          >
                            <LabelPopup
                              setLabelData={setLabelData}
                              labelData={labelData}
                              cardDetail={cardDetail}
                              setgetId={setgetId}
                              addLabelFunc={addLabelFunc}
                              updateLabelFunc={updateLabelFunc}
                              addNewLabelFunc={addNewLabelFunc}
                              colors={colors}
                              setSelectedColor={setSelectedColor}
                              selectedColor={selectedColor}
                              getTaskId={getTaskId}
                              card={card}
                            />
                          </div>
                        ) : getId == 2 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 2 ? 'thirdpopup' : ''
                            }`}
                          >
                            <DatesPopup
                              setgetId={setgetId}
                              cardDetail={cardDetail}
                              setSavedDate={setSavedDate}
                              saveDate={saveDate}
                            />
                          </div>
                        ) : getId == 3 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 3 ? 'fourthpopup' : ''
                            }`}
                          >
                            <AttachmentPopup
                              setgetId={setgetId}
                              handleFileChange={handleFileChange}
                            />
                          </div>
                        ) : getId == 4 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 4 ? 'fifthpopup' : ''
                            }`}
                          >
                            <CoverPopup
                              setgetId={setgetId}
                              cardDetail={cardDetail}
                              setShowCover={setShowCover}
                              colors={colors}
                              handleFileCoverChange={handleFileCoverChange}
                              coverAttactment={coverAttactment}
                              setCoverAttachment={setCoverAttachment}
                            />
                          </div>
                        ) : getId == 6 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 6 ? 'sixpopup' : ''
                            }`}
                          >
                            <MoveDepartment
                              setgetId={setgetId}
                              cardDetail={cardDetail}
                              handleClose={handleClose}
                              fetchCardsForPopUp={fetchCardsForPopUp}
                            />
                          </div>
                        ) : getId == 7 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 7 ? 'sevenPopup' : ''
                            }`}
                          >
                            <AddClient
                              setgetId={setgetId}
                              client={client}
                              cardDetail={cardDetail}
                            />
                          </div>
                        ) : getId == 8 ? (
                          <div
                            className={`dropdown-menu add-member-drop ${
                              getId == 8 ? 'sevenPopup' : ''
                            }`}
                          >
                            <AddTeam
                              setgetId={setgetId}
                              teams={team}
                              cardDetail={cardDetail}
                            />
                          </div>
                        ) : (
                          ''
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        )}
      </Modal>
      <AttachmentModal showLoadingAttachment={showLoadingAttachment} />
    </div>
  );
};
